import Settings from './Settings.vue'
import List from './List.vue'
import New from './New.vue'
import Edit from './Edit.vue'
import Delete from './Delete.vue'
import { Route } from 'vue-router'

export const All = [Settings, List, New, Edit, Delete]

export default {
  Settings,
  List,
  New,
  Edit,
  Delete
}

export const RouteConfig = [
  {
    path: 'users',
    component: Settings,
    name: 'settings-users',
    children: [
      {
        path: 'list',
        component: List,
        name: 'settings-users-list',
        props: function(route: Route) {
          return {
            clientId: route?.params?.clientId
          }
        }
      },
      {
        path: ':userId/edit/',
        component: Edit,
        name: 'settings-users-edit',
        props: function(route: Route) {
          return {
            clientId: route?.params?.clientId,
            userId: route?.params?.userId
          }
        }
      },
      {
        path: 'new',
        component: New,
        name: 'settings-users-new',
        props: function(route: Route) {
          return {
            clientId: route?.params?.clientId
          }
        }
      },
      {
        path: ':userId/delete',
        component: Delete,
        name: 'settings-users-delete',
        props: function(route: Route) {
          return {
            clientId: route?.params?.clientId,
            userId: route?.params?.userId
          }
        }
      },
      {
        path: '',
        component: List,
        props: function(route: Route) {
          return {
            clientId: route?.params?.clientId
          }
        }
      }
    ]
  }
]
